import { privateApi } from 'api'
import { AxiosResponse } from 'axios'

export interface ILandingPage {
  _id: string
  slug: string
  title: string
  status: string
  exclusive_slots?: boolean
  staff_emails?: string[] // пул почт персонала: подставляется в форму новой услуги
}

export const landingPagesApi = {
  // мета лендинг-страницы по slug (нужен _id для привязки баннеров/услуг)
  getBySlug: (slug: string): Promise<AxiosResponse<ILandingPage>> => {
    return privateApi.get(`/landing-page/${slug}`)
  },

  update: (
    slug: string,
    data: { exclusive_slots?: boolean }
  ): Promise<AxiosResponse<ILandingPage>> => {
    return privateApi.patch(`/admin/landing-page/${slug}`, data)
  }
}
